<template lang="pug">
    button(
        ref="_in",
        type="submit",
        class="_btn",
        :class="{ [tone]: tone, [appearance]: appearance, _busy: busy || dispatching }",
        :style="{ width, height }",
        :id="id",
        :disabled="disabled || busy || dispatching",
        :inert="inert",
        :tabindex="inert ? -1 : tabindex",
        v-on="__on")
        slot &#xfeff;
        span(v-if="busy || dispatching", class="_busyi")
            slot(name="busy")
                ib-progress-dots
</template>

<script>
    import button from './ib-button.vue'

    /**
    * A button that triggers a form's validation and submission handlers
    */
    export default {
        name: 'ib-button-submit',
        mixins: [button],

        props: {
            /**
             * DOM `id` of form to submit; by default the enclosing form will be submitted.
             */
            for: String,
            /**
             * Semantic color class.
             */
            tone: {
                type: String,
                default: 'accent'
            }
        },

        methods: {
            _click(e) {
                if (this.for) {
                    const el = document.getElementById(this.for);
                    if (!el) {
                        throw new Error(this.for + ' not found');
                    }
                    let o = el.__vue__;
                    while (o) {
                        if (o.isForm) {
                            o._add(this);
                            const promise = o.submit()
                            if (promise?.finally) {
                                promise.finally(() => {
                                    o._remove(this);
                                });
                            } else {
                                o._remove(this);
                            }
                            break;
                        }
                        if (o.$children.length != 1) {
                            return;
                        }
                        o = o.$children[0];
                    }
                    e.preventDefault();
                }
            }
        }
    }
</script>

<ib-example id="basic" name="Basic">
    <template lang="pug">
        ib-form(class="border inset-16", @submit="submit")
            ib-field(name="stuff")
            ib-button-submit Submit
    </template>
    <script>
        {
            methods: {
                submit(data) {
                    this.$alert(JSON.stringify(data));
                }
            }
        }
    </script>
</ib-example>
